<div class="col-sm-12">

    <h3>Cadastro de nova dispensa/inegibilidade</h3>
    <hr>

    <div class="col-sm-12">

        <ul class="timeline">

            <li class="time-label">
                <span class="bg-red">Etapa 1</span>
            </li>
            <li>
                <i class="fa fa-clone bg-blue"></i>
                <div class="timeline-item">

                    <h3 class="timeline-header">
                        <a (click)="openEtapa1()" style="cursor: pointer;">1 - CONCEDENTE, TÍTULO E DESCRIÇÃO</a>
                    </h3>

                    <div class="timeline-body" *ngIf="etapa1">

                        <div class="col-sm-12">

                            <div class="col-sm-12">
                                <div class="ui-g-6 ui-fluid" style="padding: 0;"
                                    *ngIf="isAdmin">
                                    <label>Entidade Concedente:</label>
                                    <p-select name="entidadeConcedente" [options]="entidadesConcedente"
                                        placeholder="Selecione" [filter]="true"
                                        [(ngModel)]="dispensaInexigibilidade.entidadeConcedente.id"
                                        (onChange)="entidadeSelecionada($event.value)" required></p-select>
                                </div>
                            </div>

                            <div class="col-sm-12">
                                <hr>
                            </div>

                            <div class="form-group col-sm-12">
                                <label>Título:</label>
                                <input type="text" name="titulo" [(ngModel)]="dispensaInexigibilidade.titulo"
                                    class="form-control">
                            </div>

                            <div class="col-sm-12">
                                <p-editor [(ngModel)]="dispensaInexigibilidade.descricao">
                                </p-editor>
                            </div>

                        </div>
                    </div>

                    <div class="timeline-footer" *ngIf="etapa1">
                        <a class="btn btn-primary btn-sm" (click)="openEtapa2()">Próximo</a>
                    </div>
                </div>
            </li>


            <li class="time-label">
                <span class="bg-red">Etapa 2</span>
            </li>
            <li>
                <i class="fa fa-clone bg-blue"></i>
                <div class="timeline-item">

                    <h3 class="timeline-header">
                        <a (click)="openEtapa2()" style="cursor: pointer;">2 – TIPO DE PROCESSO</a>
                    </h3>

                    <div class="timeline-body" *ngIf="etapa2">

                        <div class="col-sm-12">
                            <h4>Defina o tipo de processo:</h4>
                            <div class="form-group">
                                <div class="radio">
                                    <label>
                                        <input type="radio" name="optionsRadios" id="optionsRadios2"
                                            [checked]="dispensaInexigibilidade.dispensa"
                                            (click)="tipoProcessoDispensa()"> Processo por Dispensa
                                    </label>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <label>
                                        <input type="radio" name="optionsRadios" id="optionsRadios3"
                                            [checked]="dispensaInexigibilidade.inexigibilidade"
                                            (click)="tipoProcessoInexigibilidade()"> Processo por Inexigibilidade
                                    </label>
                                </div>
                            </div>
                        </div>

                        <!--AJUSTE TEMPORÁRIO, ELIMINANDO A ALTERNATIVA CREDENCIAMENTO (disabled e checked)-->
                        <!-- <div class="ui-g-12 ui-fluid" *ngIf="dispensaInexigibilidade.dispensa">
                                <div class="ui-g-12 ui-md-6 ui-fluid">
                                    <h4>Selecione a área de atuação</h4>
                                    <label>
                                        <input disabled type="radio" name="optionDispensa" id="optionDispensa1"
                                            value="option1" (click)="tipoDispensaCredenciamento()"> Saúde,
                                        Educação ou Assistência social
                                    </label>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <label>
                                        <input type="radio" checked disabled name="optionDispensa" id="optionDispensa2"
                                            value="option2" (click)="tipoDispensaOutro()"> Outra
                                        área
                                    </label>
                                </div>
                            </div> -->
                    </div>

                    <div class="timeline-footer" *ngIf="etapa2">
                        <a class="btn btn-primary btn-sm" (click)="openEtapa1()">Voltar</a>
                        <a class="btn btn-primary btn-sm" (click)="openEtapa3()">Próximo</a>
                    </div>
                </div>
            </li>


            <li class="time-label">
                <span class="bg-red">Etapa 3</span>
            </li>
            <li>
                <i class="fa fa-clone bg-blue"></i>
                <div class="timeline-item">

                    <h3 class="timeline-header">
                        <a (click)="openEtapa3()" style="cursor: pointer;">3 – ESCOLHA DA ENTIDADE</a>
                    </h3>

                    <div class="timeline-body" *ngIf="etapa3">

                        <div *ngIf="dispensaCredenciamento">
                            <div class="ui-g-12 ui-md-6 ui-fluid">
                                <label>Edital de credenciamento:</label>
                                <p-select name="editalCredenciamento" [options]="editaisCredenciamento"
                                    placeholder="Selecione" [filter]="true"
                                    [(ngModel)]="planoTrabalho.editalCredenciamento.id" required
                                    (onChange)="buscarEixosEdital($event.value)"></p-select>
                            </div>
                            <div class="ui-g-12 ui-md-6 ui-fluid">
                                <label>Eixo Programa:</label>
                                <p-select name="eixoPrograma" [options]="eixosEdital" placeholder="Selecione" [filter]="true" [(ngModel)]="planoTrabalho.eixoPrograma.id"
                                    (onChange)="buscarEntidadesCredenciadas($event.value)"></p-select>
                            </div>
                            <div class="ui-g-12 ui-fluid">
                                <label>OSC(Credenciada):</label>
                                <p-select name="oscCredenciada" [options]="proponentesCredenciados"
                                    placeholder="Selecione" [filter]="true"
                                    (onChange)="oscSelecionada($event.value)"
                                    [(ngModel)]="planoTrabalho.entidadeProponente.id"></p-select>
                            </div>
                            <div class="ui-g-12 ui-fluid">
                                <label>Justificativa:</label>
                                <p-editor name="justificativaDispensa" [(ngModel)]="planoTrabalho.justificativa"
                                    [style]="{'height':'250px', 'background':'#fff'}"></p-editor>
                            </div>
                            <div class="ui-g-12 ui-fluid">
                                <div style="float:right" class="timeline-footer">
                                    <a class="btn btn-primary btn-sm" (click)="adicionaPlanoTrabalho()">Adicionar</a>
                                </div>
                            </div>
                            <hr>
                            <div *ngIf="planosDaDispensa.length != 0" class="col-sm-12">

                                <div class="box">
                                    <div class="box-header">
                                        <h3 class="box-title">OSCs adicionadas</h3>
                                    </div>


                                    <div class="box-body table-responsive no-padding">
                                        <table class="table table-hover">
                                            <tbody>
                                                <tr>
                                                    <th>Entidade Proponente</th>
                                                    <th>Edital de credenciamento</th>
                                                    <th>Eixo programa</th>
                                                    <th class="text-center" style="min-width: 65px;">Ações</th>
                                                </tr>

                                                <tr *ngFor="let plano of planosDaDispensa">
                                                    <td>{{ plano.entidadeProponente.nome }}</td>
                                                    <td>{{ plano.editalCredenciamento.titulo }}</td>
                                                    <td>{{ plano.eixoPrograma.nome }}</td>
                                                    <td class="text-center">
                                                        <i (click)="excluirPlano(plano)" class="fa fa-trash"
                                                            style="font-size: 20px; cursor:pointer; color: #ff3636ab;"></i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <hr>
                            </div>
                        </div>

                        <div *ngIf="!dispensaInexigibilidade.inexigibilidade && !dispensaOutro" class="col-sm-12">
                            <h4 class="text-muted">É necessário definir um tipo de processo.</h4>
                        </div>

                        <div *ngIf="dispensaInexigibilidade.inexigibilidade || dispensaOutro">

                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <div class="ui-g-12 ui-fluid" style="padding: 0;">
                                        <label>OSC:</label>
                                        <p-select name="entidadeProponente" [options]="oscs" placeholder="Selecione" [filter]="true"
                                            [(ngModel)]="planoTrabalho.entidadeProponente.id" required></p-select>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <label>Data de publicação da justificativa:</label>
                                    <input name="data" [(ngModel)]="dispensaInexigibilidade.dataPublicacao" type="date"
                                        class="form-control">
                                </div>
                                <div class="col-sm-12">
                                    <hr>
                                </div>
                                <div class="col-sm-12">
                                    <p-editor [(ngModel)]="planoTrabalho.justificativa"></p-editor>
                                </div>
                            </div>

                        </div>

                    </div>
                    <div class="timeline-footer" *ngIf="etapa3">
                        <a class="btn btn-primary btn-sm" (click)="openEtapa2()">Voltar</a>
                        <a class="btn btn-primary btn-sm" (click)="openEtapa4()">Próximo</a>
                    </div>
                </div>
            </li>

            <li class="time-label">
                <span class="bg-red">Etapa 4</span>
            </li>
            <li>
                <i class="fa fa-clone bg-blue"></i>
                <div class="timeline-item">

                    <h3 class="timeline-header">
                        <a (click)="openEtapa4()" style="cursor: pointer;">4 – ORÇAMENTO PROJETO</a>
                    </h3>

                    <div class="timeline-body" *ngIf="etapa4">

                        <div class="form-group col-sm-6">
                            <label>Unidade Orçamentária:</label>
                            <input type="text" name="name" [(ngModel)]="planoTrabalho.et2UnidadeOrcamentaria"
                                class="form-control">
                        </div>
                        <div class="form-group col-sm-6">
                            <label>Fonte:</label>
                            <input type="text" name="name" [(ngModel)]="planoTrabalho.et2Fonte" class="form-control">
                        </div>
                        <div class="form-group col-sm-6">
                            <label>Dotação Orçamentária:</label>
                            <input type="text" name="name" [(ngModel)]="planoTrabalho.et2DotacaoOrcamentaria"
                                class="form-control">
                        </div>
                        <div class="form-group col-sm-6">
                            <label>Elemento Despesa:</label>
                            <input type="text" name="name" [(ngModel)]="planoTrabalho.et2ElementoDespesa"
                                class="form-control">
                        </div>
                        <div class="form-group col-sm-3">
                            <label>Valor:</label>
                            <input type="text" name="name" [(ngModel)]="planoTrabalho.et2Valor" class="form-control"
                                placeholder="R$ 0.000,00" currencyMask
                                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left' }">
                        </div>
                        <div class="form-group col-sm-9">
                            <label>Valor por extenso:</label>
                            <input type="text" name="name" [(ngModel)]="planoTrabalho.et2ValorExtenso"
                                class="form-control">
                        </div>

                    </div>

                    <div class="timeline-footer" *ngIf="etapa4">
                        <a class="btn btn-primary btn-sm" (click)="openEtapa3()">Voltar</a>
                        <a class="btn btn-primary btn-sm" (click)="openEtapa5()">Próximo</a>
                    </div>
                </div>
            </li>

            <li class="time-label">
                <span class="bg-red">Etapa 5</span>
            </li>
            <li>
                <i class="fa fa-clone bg-blue"></i>
                <div class="timeline-item">

                    <h3 class="timeline-header">
                        <a (click)="openEtapa5()" style="cursor: pointer;">5 – CONFIRMAR CADASTRO</a>
                    </h3>

                    <div class="timeline-body" *ngIf="etapa5">

                        <p>Tipo de processo:</p>
                        <h4 class="text-light-blue"><b>{{ retornaTipoProcesso() }}</b></h4>
                        <hr>
                        <p>Título e descrição:</p>
                        <div style="border: 1px solid #eee; margin-left: 12px; padding: 10px;">
                            <h4 class="text-light-blue"><b>{{ dispensaInexigibilidade.titulo }}</b></h4>
                            <hr>
                            <div [innerHtml]="dispensaInexigibilidade.descricao"></div>
                        </div>
                        <hr>
                        <p>Justificativa / Data publicação / Orçamento / Entidade(s):</p>
                        <div style="border: 1px solid #eee; margin-left: 12px; padding: 10px;">
                            <div *ngIf="!dispensaCredenciamento">
                                <h4 class="text-light-blue"><b>{{ retornaNomeEntidade() }}</b></h4>
                                <hr>
                                <p><b>Justificativa:</b></p>
                                <div [innerHtml]="planoTrabalho.justificativa"></div>
                                <hr>
                                <p><b>Data de publicação da justificativa:</b>
                                    {{ dispensaInexigibilidade.dataPublicacao | date: 'dd/MM/yyyy' }}</p>
                                <hr>
                                <p><b>Orçamento projeto:</b></p>
                                <dl class="dl-horizontal">
                                    <dt>Unidade orçamentária: </dt>
                                    <dd>{{ planoTrabalho.et2UnidadeOrcamentaria }}</dd>
                                    <dt>Fonte: </dt>
                                    <dd>{{ planoTrabalho.et2Fonte }}</dd>
                                    <dt>Dotação orçamentária: </dt>
                                    <dd>{{ planoTrabalho.et2DotacaoOrcamentaria }}</dd>
                                    <dt>Elemento despesa: </dt>
                                    <dd>{{ planoTrabalho.et2ElementoDespesa }}</dd>
                                    <dt>Valor: </dt>
                                    <dd>{{ planoTrabalho.et2Valor }}</dd>
                                    <dt>Valor por extenso: </dt>
                                    <dd>{{ planoTrabalho.et2ValorExtenso }}</dd>
                                </dl>
                            </div>
                            <div *ngIf="dispensaCredenciamento">
                                <div class="col-sm-12">
                                    <table class="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <th>Entidade Proponente</th>
                                                <th>Edital de credenciamento</th>
                                                <th>Eixo programa</th>
                                                <th>Justificativa</th>
                                            </tr>

                                            <tr *ngFor="let plano of planosDaDispensa">
                                                <td>{{ plano.entidadeProponente.nome }}</td>
                                                <td>{{ plano.editalCredenciamento.titulo }}</td>
                                                <td>{{ plano.eixoPrograma.nome }}</td>
                                                <td>
                                                    <div [innerHtml]="plano.justificativa"></div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="timeline-footer" *ngIf="etapa5">
                        <a class="btn btn-primary btn-sm" (click)="openEtapa4()">Voltar</a>
                        <a class="btn btn-success btn-sm" (click)="salvar()">SALVAR</a>
                    </div>
                </div>
            </li>

            
        </ul>

    </div>

</div>